const MIN_SELECTABLE_MINUTES_LEFT_TO_START = 30;
const MIN_TIME_LEFT_TO_START_TEXT = "30 Minuten";
const DEFAULT_MINUTES_LEFT_TO_START = 30;

const ALLOWED_IMAGE_FORMATS = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
const ALLOWED_VIDEO_FORMATS = ["mp4", "mpeg", "mov"];
const ALLOWED_AUDIO_FORMATS = ["mp3", "wav", "ogg", "flac"];

const VERTICAL_TEMPLATE_IDS = ["TikTokVideo", "VerticalVideo", "VerticalImage", "ShapeImage"];

// LINKED IN
const linkedInLands = ["Bitte wählen", "USA", "Deutschland", "Niederlande", "Tschechien"];
const linkedInCareerLevelsMapping = {
  Führungskraft: "6",
  Direktion: "5",
  "Senior Level": "4",
  Mitarbeiter: "3",
  Einstiegslevel: "2",
  Praktikum: "1",
  "Nicht zutreffend": "0"
};
const linkedInCareerLevels = Object.keys(linkedInCareerLevelsMapping).sort();
const linkedInEmploymentTypesMapping = {
  Vollzeit: "F",
  Teilzeit: "P",
  Vertrag: "C",
  Befristet: "T",
  Sonstige: "O",
  Volunteer: "V"
};
const linkedInEmploymentTypes = Object.keys(linkedInEmploymentTypesMapping).sort();
const linkedInSectorsMapping = {
  "Bitte wählen": "0",
  Buchhaltung: "47",
  "Fluggesellschaften/Luftfahrt": "94",
  "Alternative Streitbeilegung": "120",
  "Alternative Medizin": "125",
  Animation: "127",
  "Bekleidung & Mode": "19",
  "Architektur & Planung": "50",
  "Kunst und Handwerk": "111",
  Automobilindustrie: "53",
  "Luftfahrt; Luft- und Raumfahrt": "52",
  Bankwesen: "41",
  Biotechnologie: "12",
  Rundfunkmedien: "36",
  Baustoffe: "49",
  "Geschäftsbedarf und-einrichtung": "138",
  Kapitalmärkte: "129",
  Chemikalien: "54",
  "Bürgerliche und soziale Organisation": "90",
  Tiefbau: "51",
  Gewerbeimmobilien: "128",
  "Computer- und Netzwerksicherheit": "118",
  Computerspiele: "109",
  Computerhardware: "3",
  Computernetzwerke: "5",
  "Computer Software": "4",
  Konstruktion: "48",
  Unterhaltungselektronik: "24",
  Konsumgüter: "25",
  Verbraucherdienste: "91",
  Kosmetik: "18",
  Molkerei: "65",
  "Verteidigung & Raumfahrt": "1",
  Design: "99",
  "E-Learning": "69",
  Bildungsmanagement: "132",
  "Elektro-/Elektronikfertigung": "112",
  Unterhaltung: "28",
  Umweltdienstleistungen: "86",
  Veranstaltungsservice: "110",
  Vorstandsbüro: "76",
  Hausmeisterservice: "122",
  Landwirtschaft: "63",
  Finanzdienstleistungen: "43",
  Kunst: "38",
  Fischerei: "66",
  "Speisen und Getränke": "34",
  Lebensmittelproduktion: "23",
  Spendensammlung: "101",
  Möbel: "26",
  "Glücksspiel & Casinos": "29",
  "Glaskeramik & Beton": "145",
  Staatsverwaltung: "75",
  Regierungsbeziehungen: "148",
  Grafikdesign: "140",
  "Gesundheit, Wellness und Fitness": "124",
  "Höhere Bildung": "68",
  "Krankenhau & Gesundheitsvorsorge": "14",
  Hotellerie: "31",
  "Human Resources": "137",
  "Import und Export": "134",
  "Individual- & Familienservices": "88",
  "Industrielle Automatisierung": "147",
  Informationsdienste: "84",
  "Informationstechnologie und Dienstleistungen": "96",
  Versicherung: "42",
  "Internationale Angelegenheiten": "74",
  "Internationaler Handel und Entwicklung": "141",
  Internet: "6",
  "Investment Banking": "45",
  Investitionsmanagement: "46",
  Justiz: "73",
  Strafverfolgung: "77",
  Rechtspraxis: "9",
  Rechtsberatung: "10",
  "Gesetzgebendes Amt": "72",
  "Freizeitreisen & Tourismus": "30",
  Bibliotheken: "85",
  "Logistik und Lieferkette": "116",
  "Luxusgüter & Schmuck": "143",
  Maschinen: "55",
  Unternehmensberatung: "11",
  "Marine / Maritine Wirtschafts": "95",
  Marktforschung: "97",
  "Vermarktung und Werbung": "80",
  "Maschinenbau oder Wirtschaftsingenieurwesen": "135",
  Medienproduktion: "126",
  "Medizinische Geräte": "17",
  Arztpraxis: "13",
  "Psychische Gesundheitsfürsorge": "139",
  Militär: "71",
  "Bergbau & Metalle": "56",
  "Spielfilme und Filme": "35",
  "Museen und Institutionen": "37",
  Musik: "115",
  Nanotechnologie: "114",
  "Zeitungen ": "81",
  "Management gemeinnütziger Organisationen": "100",
  "Öl & Energie": "57",
  "Online Medien": "113",
  "Outsourcing/Offshoring": "123",
  "Paket-/ Frachtzustellung": "87",
  "Verpackung und Behälter Container": "146",
  "Papier & Forstprodukte": "61",
  "Darstellende Künste": "39",
  "Pharmazie & Arzneimittel": "15",
  Philanthropie: "131",
  Fotografie: "136",
  Kunststoffe: "117",
  "Politische Organisation": "107",
  "Primar-/ Sekundarschulbildung": "67",
  Drucken: "83",
  "Professionelles Training & Coaching": "105",
  "Programm-Entwicklung": "102",
  Staatstätigkeit: "79",
  "Öffentlichkeitsarbeit und Kommunikation": "98",
  "Öffentliche Sicherheit": "78",
  Verlagswesen: "82",
  Eisenbahnherstellung: "62",
  Viehzucht: "64",
  Grundeigentum: "44",
  "Freizeiteinrichtungen und -dienstleistungen": "40",
  "Religiöse Institutionen": "89",
  "Erneuerbare Energien & Umwelt": "144",
  Forschung: "70",
  Restaurants: "32",
  Einzelhandel: "27",
  "Sicherheit und Ermittlungen": "121",
  Halbleiter: "7",
  Schiffbau: "58",
  Sportwaren: "20",
  Sport: "33",
  "Personalbeschaffung und Recruiting": "104",
  Supermärkte: "22",
  Telekommunikation: "8",
  Textilien: "60",
  Denkfabriken: "130",
  Tabak: "21",
  "Übersetzung und Lokalisierung": "108",
  "Transport / LKW / Eisenbahn": "92",
  Dienstprogramme: "59",
  "Risikokapital & Private Equity": "106",
  Veterinär: "16",
  Lagerung: "93",
  Großhandel: "133",
  "Wein und Spirituosen": "142",
  Rundfunk: "119",
  "Schreiben und Bearbeiten": "103"
};
const linkedInSectors = Object.keys(linkedInSectorsMapping).sort();
const linkedInFunctionsMapping = {
  "Bitte wählen": "",
  "Buchhaltung / Wirtschaftsprüfung": "acct",
  Verwaltung: "adm",
  Werbung: "advr",
  Analyst: "anls",
  "Kunst / Kreativ": "art",
  "Geschäftsentwicklung / Akquise": "bd",
  Beratung: "cnsl",
  Kundendienst: "cust",
  Design: "dist",
  Verteilung: "dsgn",
  Bildung: "edu",
  Maschinenbau: "eng",
  Finanzen: "fin",
  "Generelles Geschäft": "genb",
  Gesundheitsdienstleister: "hcpr",
  "Human Resources": "hr",
  Informationstechnologie: "it",
  Rechtliches: "lgl",
  Management: "mgmt",
  Herstellung: "mnfc",
  Marketing: "mrkt",
  Sonstiges: "othr",
  "Produkt Management": "pr",
  Produktion: "prch",
  Projektmanagement: "prdm",
  Öffentlichkeitsarbeit: "prjm",
  Einkauf: "prod",
  Qualitätskontrolle: "qa",
  Forschung: "rsch",
  Vertrieb: "sale",
  Wissenschaft: "sci",
  Strategieplanung: "stra",
  Lieferkette: "supl",
  Ausbildung: "trng",
  "Schreiben / Bearbeiten": "wrt"
};
const linkedInFunctions = Object.keys(linkedInFunctionsMapping).sort();

// INDEED
const indeedBundeslands = [
  "Bitte wählen",
  "Baden-Württemberg",
  "Bayern",
  "Berlin",
  "Brandenburg",
  "Bremen",
  "Hamburg",
  "Hessen",
  "Mecklenburg-Vorpommern",
  "Niedersachsen",
  "Nordrhein-Westfalen",
  "Rheinland-Pfalz",
  "Saarland",
  "Sachsen",
  "Sachsen-Anhalt",
  "Schleswig-Holstein",
  "Thüringen"
];

// Top Banner
const bannerSettings = {
  stagingWarning: {
    mainText: "Änderungen nicht veröffentlicht",
    mainText_locale: {
      en: "Changes not published",
      de: "Änderungen nicht veröffentlicht",
      default: "Änderungen nicht veröffentlicht"
    },
    backgroundColor: "rgb(244 231 227)",
    color: "rgb(255, 111, 30)",
    subColor: "rgb(255, 111, 30, 0.5)",
    extraText: `Click "Publish with email" to share the changes with the customer`,
    extraText_locale: {
      en: "We automatically extract data from your job advertisement. Of course, you can still customize the ad.",
      de: `Klicke auf "Veröffentlichen mit E-Mail" um die Änderungen mit dem Kunden zu teilen`,
      default: `Klicke auf "Veröffentlichen mit E-Mail" um die Änderungen mit dem Kunden zu teilen`
    }
  },
  booking: {
    mainText: "Automatically generated display",
    icon: "/images/create_post_info_icon.svg",
    backgroundColor: "#e9e8ff",
    extraText:
      "We automatically extract data from your job advertisement. Of course, you can still customize the advertisement."
  },
  SCHEDULED: {
    mainText: "Ihre Anzeige geht gleich LIVE",
    mainText_locale: {
      en: "Your Ad is about to be LIVE",
      de: "Ihre Anzeige geht gleich LIVE",
      default: "Ihre Anzeige geht gleich LIVE"
    },
    icon: "/images/create_post_live_icon.svg",
    backgroundColor: "rgb(255, 174, 174, 0.1)",
    color: "rgb(255, 174, 174, 1)",
    extraText: "Super! Sie haben Ihre Kampagne vorbereitet, damit sie bald LIVE geschaltet wird.",
    extraText_locale: {
      en: "Great! You have prepared your campaign to go LIVE soon.",
      de: "Super! Sie haben Ihre Kampagne vorbereitet, damit sie bald LIVE geschaltet wird.",
      default: "Super! Sie haben Ihre Kampagne vorbereitet, damit sie bald LIVE geschaltet wird."
    }
  },
  IN_PROGRESS: {
    mainText: "Wir arbeiten daran",
    mainText_locale: {
      en: "We are working on it",
      de: "Wir arbeiten daran",
      default: "Wir arbeiten daran"
    },
    icon: "/images/create_post_info_icon.svg",
    backgroundColor: "rgb(255, 111, 30, 0.1)",
    color: "rgb(255, 111, 30, 0.8)",
    extraText:
      "Vielen Dank für Ihre Nachricht! Ein Kampagnen Manager meldet sich in Kürze bei Ihnen.",
    extraText_locale: {
      en: "Thank you for your message! A campaign manager will get back to you shortly.",
      de: "Vielen Dank für Ihre Nachricht! Ein Kampagnen Manager meldet sich in Kürze bei Ihnen.",
      default:
        "Vielen Dank für Ihre Nachricht! Ein Kampagnen Manager meldet sich in Kürze bei Ihnen."
    }
  },
  WAITING_FOR_APPROVAL: {
    mainText: "Ihre Kampagne wartet auf Ihre Freigabe",
    mainText_locale: {
      en: "Your campaign is waiting for your approval",
      de: "Ihre Kampagne wartet auf Ihre Freigabe",
      default: "Ihre Kampagne wartet auf Ihre Freigabe"
    },
    icon: "/images/create_post_info_icon.svg",
    backgroundColor: "#e9e8ff",
    color: "#8066FF",
    extraText: "Mit Ihrem „Go“ geht’s los. Alles passt? ✅ Dann setzen Sie die Kampagne auf „Go“.",
    extraText_locale: {
      en: "With your „Go“ you're off. Everything fits? ✅ Then set the campaign to „Go“.",
      de: "Mit Ihrem „Go“ geht’s los. Alles passt? ✅ Dann setzen Sie die Kampagne auf „LIVE“.",
      default: "Mit Ihrem „Go“ geht’s los. Alles passt? ✅ Dann setzen Sie die Kampagne auf „LIVE“."
    }
  },
  ACTIVE: {
    mainText: "Ihre Kampagne ist schon LIVE",
    mainText_locale: {
      en: "Your campaign is already LIVE",
      de: "Ihre Kampagne ist schon LIVE",
      default: "Ihre Kampagne ist schon LIVE"
    },
    icon: "/images/create_post_info_icon.svg",
    backgroundColor: "rgb(103, 228, 176, 0.1)",
    color: "rgb(103, 228, 176, 0.8)",
    extraText: "Alles erledigt 🙌 Ihre Kampagne ist bereits LIVE auf allen Kanälen.",
    extraText_locale: {
      en: "All done 🙌 Your campaign is already LIVE on all channels.",
      de: "Alles erledigt 🙌 Ihre Kampagne ist bereits LIVE auf allen Kanälen.",
      default: "Alles erledigt 🙌 Ihre Kampagne ist bereits LIVE auf allen Kanälen."
    }
  },
  FINISHED: {
    mainText: "Ihre Kampagne ist schon beendet",
    mainText_locale: {
      en: "Your campaign is already Finished",
      de: "Ihre Kampagne ist schon beendet",
      default: "Ihre Kampagne ist schon beendet"
    },
    icon: "/images/create_post_info_icon.svg",
    backgroundColor: "#58beff",
    color: "blue",
    extraText:
      "Ihre Kampagne ist nun beendet. Sie können die Ergebnisse auf Ihrem Kampagnen-Metriken-Dashboard einsehen.",
    extraText_locale: {
      en: "Your campaign is now finished. You can view the results on your campaign metrics dashboard.",
      de: "Ihre Kampagne ist nun beendet. Sie können die Ergebnisse auf Ihrem Kampagnen-Metriken-Dashboard einsehen.",
      default:
        "Ihre Kampagne ist nun beendet. Sie können die Ergebnisse auf Ihrem Kampagnen-Metriken-Dashboard einsehen."
    }
  },
  CANCELLED: {
    mainText: "Ihre Kampagne ist abgesagt",
    mainText_locale: {
      en: "Your campaign is Canceled",
      de: "Ihre Kampagne ist abgesagt",
      default: "Ihre Kampagne ist abgesagt"
    },
    icon: "/images/create_post_info_icon.svg",
    backgroundColor: "#eebaff",
    color: "#ca2efe",
    extraText:
      "Ihre Kampagne wurde auf Ihren Wunsch hin storniert. Bitte kontaktieren Sie Ihren Kampagnenmanager, wenn Sie weitere Informationen benötigen.",
    extraText_locale: {
      en: "Your campaign has been cancelled at your request. Please contact your campaign manager if you need more information.",
      de: "Ihre Kampagne wurde auf Ihren Wunsch hin storniert. Bitte kontaktieren Sie Ihren Kampagnenmanager, wenn Sie weitere Informationen benötigen.",
      default:
        "Ihre Kampagne wurde auf Ihren Wunsch hin storniert. Bitte kontaktieren Sie Ihren Kampagnenmanager, wenn Sie weitere Informationen benötigen."
    }
  },
  REJECTED: {
    mainText: "Ihre Kampagne ist Abgelehnt",
    mainText_locale: {
      en: "Your campaign is Rejected",
      de: "Ihre Kampagne ist Abgelehnt",
      default: "Ihre Kampagne ist Abgelehnt"
    },
    icon: "/images/create_post_info_icon.svg",
    backgroundColor: "#eebaff",
    color: "#ca2efe",
    extraText:
      "Leider mussten wir Ihre Kampagne ablehnen, da sie nicht mit unseren Nutzungsbedingungen übereinstimmt. Bitte kontaktieren Sie Ihren Kampagnenmanager für weitere Informationen.",
    extraText_locale: {
      en: "Unfortunately, we had to reject your campaign because it does not comply with our terms of use. Please contact your campaign manager for more information.",
      de: "Leider mussten wir Ihre Kampagne ablehnen, da sie nicht mit unseren Nutzungsbedingungen übereinstimmt. Bitte kontaktieren Sie Ihren Kampagnenmanager für weitere Informationen.",
      default:
        "Leider mussten wir Ihre Kampagne ablehnen, da sie nicht mit unseren Nutzungsbedingungen übereinstimmt. Bitte kontaktieren Sie Ihren Kampagnenmanager für weitere Informationen."
    }
  },
  PAUSED: {
    mainText: "Ihre Kampagne ist Pausiert",
    mainText_locale: {
      en: "Your campaign is Paused",
      de: "Ihre Kampagne ist Pausiert",
      default: "Ihre Kampagne ist Pausiert"
    },
    icon: "/images/create_post_info_icon.svg",
    backgroundColor: "#dceaff",
    color: "#0b4bff",
    extraText:
      "Ihre Kampagne wurde pausiert. Für weitere Informationen wenden Sie sich bitte an Ihren Kampagnenmanager/in.",
    extraText_locale: {
      en: "Your campaign has been paused. Please contact your campaign manager for more information.",
      de: "Ihre Kampagne wurde pausiert. Für weitere Informationen wenden Sie sich bitte an Ihren Kampagnenmanager/in.",
      default:
        "Ihre Kampagne wurde pausiert. Für weitere Informationen wenden Sie sich bitte an Ihren Kampagnenmanager/in."
    }
  }
};

const EDITABLE_STATUS = ["WAITING_FOR_APPROVAL", "booking"];

const STATUS_WITH_SET_LIVE = ["SCHEDULED", "WAITING_FOR_APPROVAL"];

const CAMPAIGN_IS_BOOKED = [
  "IN_PROGRESS",
  "WAITING_FOR_APPROVAL",
  "SCHEDULED",
  "PAUSED",
  "FINISHED",
  "REJECTED",
  "CANCELLED"
];

const CLOUDINARY = {
  CLOUDINARY_CLOUD_NAME: "dyiuxe5fa"
};

module.exports = {
  MIN_SELECTABLE_MINUTES_LEFT_TO_START,
  MIN_TIME_LEFT_TO_START_TEXT,
  DEFAULT_MINUTES_LEFT_TO_START,
  linkedInLands,
  linkedInCareerLevelsMapping,
  linkedInCareerLevels,
  linkedInEmploymentTypesMapping,
  linkedInEmploymentTypes,
  linkedInSectorsMapping,
  linkedInSectors,
  linkedInFunctionsMapping,
  linkedInFunctions,
  indeedBundeslands,
  bannerSettings,
  EDITABLE_STATUS,
  STATUS_WITH_SET_LIVE,
  ALLOWED_VIDEO_FORMATS,
  ALLOWED_AUDIO_FORMATS,
  ALLOWED_IMAGE_FORMATS,
  CLOUDINARY,
  VERTICAL_TEMPLATE_IDS,
  CAMPAIGN_IS_BOOKED
};
